var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMediaContentEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6386 1.24212C18.4483 2.12081 14.9339 4.35882 12.9302 8.14822C9.34031 14.9376 10.8674 19.9067 9.61203 24.9236C8.35661 29.9405 4.50765 31.6221 1.73934 35.5488C-0.421448 38.6137 -0.762774 46.0688 3.10951 49.7912C6.94047 53.4447 10.4732 56.8323 17.3513 55.8001C24.1605 54.8092 27.5936 50.2201 34.7475 48.7883C41.9014 47.3564 47.8265 48.6674 51.6335 45.2696C55.6256 41.7067 59.7783 31.8522 56.2113 24.7395C53.3422 19.0184 46.3663 17.7375 42.963 12.375C39.5597 7.01254 37.9269 4.62471 34.9915 3.34246C30.9335 1.56983 27.8799 0.524104 23.6386 1.24212Z",
    fill: "#90734F",
    fillOpacity: 0.08
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 36.5H21.5C21.1022 36.5 20.7206 36.342 20.4393 36.0607C20.158 35.7794 20 35.3978 20 35V24.5C20 24.1022 20.158 23.7206 20.4393 23.4393C20.7206 23.158 21.1022 23 21.5 23H24.5L26 20.75H32L33.5 23H36.5C36.8978 23 37.2794 23.158 37.5607 23.4393C37.842 23.7206 38 24.1022 38 24.5V35C38 35.3978 37.842 35.7794 37.5607 36.0607C37.2794 36.342 36.8978 36.5 36.5 36.5Z",
    stroke: "#90734F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29 32.75C30.864 32.75 32.375 31.239 32.375 29.375C32.375 27.511 30.864 26 29 26C27.136 26 25.625 27.511 25.625 29.375C25.625 31.239 27.136 32.75 29 32.75Z",
    stroke: "#90734F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaContentEmpty);
export default __webpack_public_path__ + "static/media/media-content-empty.a475cbd8fa6d741511a117d7afe4cdae.svg";
export { ForwardRef as ReactComponent };